import { type ReadonlyURLSearchParams } from 'next/navigation';
import { createContext } from 'react';

export const SafeSearchParamsContext = createContext<ReadonlyURLSearchParams>(
  new URLSearchParams() as ReadonlyURLSearchParams,
);
